import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Layout from '../../Components/Layout';
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import '../../Assets/CSS/AppointmentLetter.css'
import { useNavigate } from "react-router-dom";
import { BigerTexts, LighterBold } from "../../Assets/CSS/Text";
import axios from "axios";

const AppointmentApprove = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const isMobile = window.innerWidth < 768;
    const [statusFilter, setStatusFilter] = useState("Pending");
    // Dummy handlers (replace with API)
    const handleViewEmployee = (emp) => {
        if (!emp.fileUrl) {
            toast.error("File not available");
            return;
        }

        window.open(emp.fileUrl, "_blank"); // open in new tab
    };


    const handleApprove = (emp) => {
        console.log("Approved", emp);
    };

    const handleReject = (emp) => {
        console.log("Rejected", emp);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const capitalizeWords = (str) =>
        str.replace(/\b\w/g, (char) => char.toUpperCase());


    const fetchAppointmentStatus = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/documents/pending`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setFilteredEmployees(res.data);
            console.log("@@@@@@@@@@@@@@@@", res.data)
        } catch (err) {
            toast.error("Failed to load employee data");
        } finally {
            setLoading(false);
        }
    };

    const tabData = filteredEmployees.filter((item) => {
        const fullName = `${item.firstName ?? ""} ${item.lastName ?? ""}`.toLowerCase();

        const matchesSearch =
            fullName.includes(searchQuery.toLowerCase()) ||
            item.potentialEmployeeId
                ?.toLowerCase()
                .includes(searchQuery.toLowerCase());

        const matchesStatus =
            (statusFilter === "Pending" && item.fileStatus === "PENDING") ||
            (statusFilter === "Approved" && item.fileStatus === "APPROVED") ||
            (statusFilter === "Rejected" && item.fileStatus === "REJECTED");

        return matchesSearch && matchesStatus;
    });


    const handleDocumentStatus = async (documentId, status) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const response = await axios.patch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/${documentId}/status?status=${status}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "*/*",
                    }
                }
            );

            console.log("API Response:", response);


            if (response.status === 200) {
                setFilteredEmployees((prev) =>
                    prev.map((item) =>
                        item.documentId === documentId
                            ? { ...item, fileStatus: status }
                            : item
                    )
                );

                // toast.success("Document updated!");
                // ✅ Show toast based on status
                if (status === "APPROVED") {
                    toast.success("Document has been approved successfully");
                } else if (status === "REJECTED") {
                    toast.error("Document has been rejected successfully");
                }
            }


        } catch (error) {
            toast.error(error.response?.data?.message || "Error updating status");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchAppointmentStatus();
    }, []);



    return (
        <Layout>
            <Toaster position="top-right" reverseOrder={false} />

            <div className="backgound-main-content">



                <div className="timesheet-header px-2">

                    {/* ================= MOBILE VIEW ================= */}
                    {isMobile ? (
                        <div>
                            <div className="header-mob-title">
                                <h2>Appointment Approval List</h2>
                            </div>

                            <div className="timesheet-controls">
                                <div className="search-bar">
                                    <input
                                        type="text"
                                        placeholder="Search name"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <Icon icon="iconamoon:search" width="20" height="20" />
                                </div>
                            </div>

                            <div className="employee-card-list">
                                {loading ? (
                                    Array.from({ length: 5 }).map((_, i) => (
                                        <div className="employee-card" key={i}>
                                            <Skeleton height={100} />
                                        </div>
                                    ))
                                ) : !tabData.length ? (
                                    <p style={{ textAlign: "center" }}>No Data Found</p>
                                ) : (
                                    tabData.map((emp, index) => {
                                        const fullName = `${emp.firstName ?? ""} ${emp.lastName ?? ""}`;
                                        return (
                                            <div className="employee-card" key={index}>
                                                <h4>{capitalizeWords(fullName)}</h4>
                                                <p>Designation: {emp.designation ?? "-"}</p>
                                                <p>Date: {emp.createdAt ? new Date(emp.createdAt).toISOString().split("T")[0] : "-"}</p>

                                                <div className="d-flex gap-2">
                                                    <button onClick={() => handleViewEmployee(emp)}>View</button>
                                                    <button onClick={() => {
                                                        if (!emp.file) {
                                                            toast.error("Cannot approve. Document not uploaded.");
                                                            return;
                                                        }
                                                        handleDocumentStatus(emp.documentId, "APPROVED", index);
                                                    }}>Approve</button>
                                                    <button onClick={() => handleDocumentStatus(emp.documentId, "REJECTED")}>Reject</button>
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>
                    ) : (

                        /* ================= DESKTOP VIEW ================= */
                        <div>
                            <div className="header-title">
                                <h2 style={BigerTexts}>Appointment Approval List</h2>
                            </div>

                            <div className="timesheet-controls">
                                <div className="search-bar" style={{ boxShadow: "none" }}>
                                    <input
                                        type="text"
                                        className="form-control border-0"
                                        placeholder="Search name"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <Icon icon="iconamoon:search" width="20" height="20" />
                                </div>
                            </div>

                            <div className="d-flex gap-2 flex-wrap mb-3">
                                {["Pending", "Approved", "Rejected"].map((status) => {

                                    const count = filteredEmployees.filter((item) => {
                                        if (status === "Pending") return item.fileStatus === "PENDING";
                                        if (status === "Approved") return item.fileStatus === "APPROVED";
                                        if (status === "Rejected") return item.fileStatus === "REJECTED";
                                        return true;
                                    }).length;

                                    return (
                                        <button
                                            key={status}
                                            className={`tab-btn ${statusFilter === status ? "active" : ""}`}
                                            onClick={() => setStatusFilter(status)}
                                        >
                                            {status} ({count})
                                        </button>
                                    );
                                })}
                            </div>

                            <div className="timesheet-table mb-4">
                                <table className="employee-table timesheet-table">
                                    <thead>
                                        <tr>
                                            <th style={LighterBold}>Name</th>
                                            <th style={LighterBold}>Designation</th>
                                            <th style={LighterBold}>Date</th>
                                            <th style={LighterBold}>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {loading ? (
                                            Array.from({ length: 5 }).map((_, index) => (
                                                <tr key={index}>
                                                    <td><Skeleton width={120} /></td>
                                                    <td><Skeleton width={100} /></td>
                                                    <td><Skeleton width={100} /></td>
                                                    <td className="d-flex gap-2">
                                                        <Skeleton width={60} height={25} />
                                                        <Skeleton width={70} height={25} />
                                                        <Skeleton width={60} height={25} />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : !tabData.length ? (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>
                                                    No Data Found
                                                </td>
                                            </tr>
                                        ) : (
                                            tabData.map((emp, index) => {
                                                const fullName = `${emp.firstName ?? ""} ${emp.lastName ?? ""}`;
                                                return (
                                                    <tr key={index}>
                                                        <td>{capitalizeWords(fullName)}</td>
                                                        <td>{emp.designation ?? "-"}</td>
                                                        <td> {emp.createdAt
                                                            ? new Date(emp.createdAt).toLocaleDateString("en-GB")
                                                            : "-"}</td>

                                                        <td>
                                                            <div className="d-flex gap-2">

                                                                {/* VIEW BUTTON */}
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    style={{ padding: "6px 16px" }}
                                                                    onClick={() => handleViewEmployee(emp)}
                                                                >
                                                                    View
                                                                </button>

                                                                {/* APPROVE BUTTON */}
                                                                <button
                                                                    className="btn-approve"
                                                                    disabled={
                                                                        emp.fileStatus === "APPROVED" ||
                                                                        emp.fileStatus === "REJECTED"
                                                                    }
                                                                    onClick={() => {
                                                                        if (
                                                                            emp.fileStatus === "APPROVED" ||
                                                                            emp.fileStatus === "REJECTED"
                                                                        ) {
                                                                            return;
                                                                        }

                                                                        handleDocumentStatus(
                                                                            emp.documentId,
                                                                            "APPROVED"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        color:
                                                                            emp.fileStatus === "APPROVED"
                                                                                ? "#22C55E"
                                                                                : emp.fileStatus === "REJECTED"
                                                                                    ? "#FF8383"
                                                                                    : "#22C55E",

                                                                        border:
                                                                            emp.fileStatus === "APPROVED" ||
                                                                                emp.fileStatus === "REJECTED"
                                                                                ? "none"
                                                                                : "1px solid #22C55E",

                                                                        background: "transparent",
                                                                        borderRadius: "8px",
                                                                        padding: "6px 16px",

                                                                        opacity:
                                                                            emp.fileStatus === "APPROVED" ||
                                                                                emp.fileStatus === "REJECTED"
                                                                                ? 0.7
                                                                                : 1,

                                                                        cursor:
                                                                            emp.fileStatus === "APPROVED" ||
                                                                                emp.fileStatus === "REJECTED"
                                                                                ? "not-allowed"
                                                                                : "pointer",

                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "5px",
                                                                    }}
                                                                >
                                                                    <Icon
                                                                        icon={
                                                                            emp.fileStatus === "APPROVED"
                                                                                ? "material-symbols:done-all-rounded"
                                                                                : emp.fileStatus === "REJECTED"
                                                                                    ? "iconoir:cancel"
                                                                                    : "material-symbols:done-rounded"
                                                                        }
                                                                        style={{
                                                                            color:
                                                                                emp.fileStatus === "REJECTED"
                                                                                    ? "#FF8383"
                                                                                    : "#22C55E",
                                                                            fontSize: "18px",
                                                                        }}
                                                                    />

                                                                    {emp.fileStatus === "APPROVED"
                                                                        ? "Approved"
                                                                        : emp.fileStatus === "REJECTED"
                                                                            ? "Rejected"
                                                                            : "Approve"}
                                                                </button>

                                                                {/* REJECT BUTTON */}
                                                                {emp.fileStatus !== "APPROVED" &&
                                                                    emp.fileStatus !== "REJECTED" ? (
                                                                    <button
                                                                        className="btn-reject"
                                                                        onClick={() =>
                                                                            handleDocumentStatus(
                                                                                emp.documentId,
                                                                                "REJECTED"
                                                                            )
                                                                        }

                                                                    >
                                                                        Reject
                                                                    </button>
                                                                ) : (
                                                                    <div style={{ width: "60px" }}></div>
                                                                )}

                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default AppointmentApprove;
